exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__BaseChart__container__1YRny {\n  margin-bottom: 15px;\n  position: relative;\n  width: 100%;\n}\n\n.dmb-web__BaseChart__gridlines__37MH1 line {\n  stroke: #ddd;\n  stroke-opacity: 0.7;\n  shape-rendering: crispEdges;\n}\n\n.dmb-web__BaseChart__gridlines__37MH1 path {\n  stroke-width: 0;\n}\n", ""]);

// exports
exports.locals = {
	"container": "dmb-web__BaseChart__container__1YRny",
	"gridlines": "dmb-web__BaseChart__gridlines__37MH1"
};